import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			ads: {},
			adPosConfig: {
				scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4688525518274277',
				home_insert: {
					mobile: [
						{
							class: 'adsbygoogle',
							style: 'display:block',
							'data-ad-client': 'ca-pub-4688525518274277',
							'data-ad-slot': '9170554297',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
						},
						{
							class: 'adsbygoogle',
							style: 'display:block',
							'data-ad-client': 'ca-pub-4688525518274277',
							'data-ad-slot': '7857472625',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
						},
					],
					pc: [
						{
							class: 'adsbygoogle',
							style: 'display:block',
							'data-ad-client': 'ca-pub-4688525518274277',
							'data-ad-slot': '9170554297',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
						},
						{
							class: 'adsbygoogle',
							style: 'display:block',
							'data-ad-client': 'ca-pub-4688525518274277',
							'data-ad-slot': '7857472625',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
						},
					],
				},
				home_recommend: [
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-4688525518274277',
						'data-ad-slot': '7857472625',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
				],
				detail_1: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-4688525518274277',
					'data-ad-slot': '1870648774',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
			},
			adsensConfig: {},
			domainConfig: {
				siteName: 'Auto Insights & Reviews',
				siteIcon: '/icon/1.svg',
				siteThemeColor: 2,
				componentOrder: [
					{
						type: 'CarRangRank',
						id: 'rangrank',
					},
					{
						type: 'CarNewRelease',
						id: 'newrelease',
					},
					{
						type: 'CarPopular',
						id: 'popular',
					},
					{
						type: 'CarRecommend',
						id: 'recommend',
					},
					{
						type: 'CarType',
						id: 'type',
					},
					{
						type: 'CarBrands',
						id: 'brands',
					},
				],
				homeBackground: {
					pc: '/background/car/home/pc/bg-pc-1.png',
					mobile: '/background/car/home/mobile/bg-m-1.png',
				},
				galleryImages: '/background/car/galleryImages/1/gallery.png',
				IAMEMAIL: 'default.support@gmail.com',
				IAmURL: 'default.url',
				ABOUTUS: 'This is the default about us description.',
				gallery: {
					title: 'Expert Auto Insights & Reviews',
					content: 'Get in-depth car reviews, expert insights, and industry trends to make informed vehicle purchasing decisions.',
				},
				meta: {
					title: ' | Expert Car Reviews',
					des: 'Get expert car reviews, in-depth vehicle insights, and the latest automotive trends at Auto Insight Hub. Your trusted source for all things cars.',
				},
				firebase: {
					apiKey: 'AIzaSyANTXpxmJvBDjpHu7zXrmweD0HG4arA8k0',
					authDomain: 'project-6604139797178678943.firebaseapp.com',
					projectId: 'project-6604139797178678943',
					storageBucket: 'project-6604139797178678943.firebasestorage.app',
					messagingSenderId: '417753823474',
					appId: '1:417753823474:web:069438035661749658f86b',
					measurementId: 'G-PBLQRSGZXB',
				},
				themeFilters: {},
				ads: 'none',
				adsense: {},
			},
			categories: [],
			recommendList: [],
			// 品牌列表数据
			brandList: [{ label: 'All', value: 'all' }],
			// 品牌列表是否已加载
			brandListLoaded: false,
			// 车辆列表页状态
			carListState: {
				// 是否从详情页返回
				fromDetail: false,
				// 当前页码
				currentPage: 1,
				// 筛选条件
				filters: {
					purpose: 'all',
					brand: 'all',
					type: 'all',
					price: 'all',
					fuel: 'all',
				},
				// 最近访问页面路径
				lastVisitedPage: '',
				// 查询参数
				queryParams: {},
			},
			// 原始推荐车辆数据（API返回的未处理数据）
			originalTopCars: [],
			// 推荐车辆数据是否已加载
			topCarsLoaded: false,
			// 上次数据加载时间戳
			topCarsLoadTime: null,
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			SET_CATEGORIES(state, categories) {
				state.categories = categories
			},
			SET_RECOMMEND_LIST(state, list) {
				state.recommendList = list
			},
			// 设置品牌列表
			SET_BRAND_LIST(state, brandList) {
				state.brandList = brandList
			},
			// 设置品牌列表加载状态
			SET_BRAND_LIST_LOADED(state, loaded) {
				state.brandListLoaded = loaded
			},
			// 设置列表页状态
			SET_CAR_LIST_STATE(state, { fromDetail, currentPage, filters, lastVisitedPage, queryParams }) {
				state.carListState = {
					fromDetail: fromDetail !== undefined ? fromDetail : state.carListState.fromDetail,
					currentPage: currentPage || state.carListState.currentPage,
					filters: filters || state.carListState.filters,
					lastVisitedPage: lastVisitedPage || state.carListState.lastVisitedPage,
					queryParams: queryParams || state.carListState.queryParams,
				}
			},
			// 设置来源页面是否为详情页
			SET_FROM_DETAIL(state, fromDetail) {
				state.carListState.fromDetail = fromDetail
			},
			// 设置当前页码
			SET_CURRENT_PAGE(state, page) {
				state.carListState.currentPage = page
			},
			// 设置筛选条件
			SET_FILTERS(state, filters) {
				state.carListState.filters = { ...state.carListState.filters, ...filters }
			},
			// 设置最近访问页面
			SET_LAST_VISITED_PAGE(state, page) {
				state.carListState.lastVisitedPage = page
			},
			// 设置查询参数
			SET_QUERY_PARAMS(state, params) {
				state.carListState.queryParams = params
			},
			// 重置列表页状态
			RESET_CAR_LIST_STATE(state) {
				state.carListState = {
					fromDetail: false,
					currentPage: 1,
					filters: {
						purpose: 'all',
						brand: 'all',
						type: 'all',
						price: 'all',
						fuel: 'all',
					},
					lastVisitedPage: '',
					queryParams: {},
				}
			},
			// 设置原始推荐车辆数据
			SET_ORIGINAL_TOP_CARS(state, data) {
				state.originalTopCars = data
				state.topCarsLoaded = true
				state.topCarsLoadTime = Date.now()
			},
			// 重置推荐车辆加载状态
			RESET_TOP_CARS_LOADED(state) {
				state.topCarsLoaded = false
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			// 获取品牌列表
			brandList: (state) => state.brandList,
			// 品牌列表是否已加载
			brandListLoaded: (state) => state.brandListLoaded,
			// 车辆列表状态
			carListState: (state) => state.carListState,
			isFromDetail: (state) => state.carListState.fromDetail,
			currentPage: (state) => state.carListState.currentPage,
			filters: (state) => state.carListState.filters,
			lastVisitedPage: (state) => state.carListState.lastVisitedPage,
			queryParams: (state) => state.carListState.queryParams,
			// 获取原始推荐车辆数据
			originalTopCars: (state) => state.originalTopCars,
			// 推荐车辆数据是否已加载
			topCarsLoaded: (state) => state.topCarsLoaded,
			// 获取上次数据加载时间戳
			topCarsLoadTime: (state) => state.topCarsLoadTime,
		},
	})
}
